<template>
  <div>
    <Mainlayout></Mainlayout>
    <div class="c-app flex-row align-items-center">
      <div class="m-0">
        <div class="container-boxs center">
          <div class="text-left">
            <div class="card-custom-web" style="height: auto">
              <br />
              <div class="text-left ml-3">
                <CRow>
                  <div style="width: 60%"></div>
                  <div style="width: 40%">
                    <div style="position: fixed; z-index: 1">
                      <div class="bg-white ml-3">
                        <Countdown
                          :date="endTime"
                          @onFinish="finish()"
                        ></Countdown>
                      </div>
                    </div>
                  </div>
                </CRow>
                <CAlert v-if="errorcomplete === true" color="danger"
                  >ERROR ! Please complete all question</CAlert
                >

                <div v-if="AnswerList.length > 0">
                  <CCard
                    class="p-1 mt-5"
                    v-for="(item, index) in AnswerList"
                    v-bind:key="item.quizId"
                  >
                    <div class="ml-3 mr-3 mt-3 mb-2">
                      <h5 class="text-left text-black bold d-flex display-6">
                        Question <span class="ml-2">{{ index + 1 }}</span>
                        <br />
                      </h5>
                      <span
                        v-html="item.question"
                        style="max-width: 100%"
                      ></span>
                      <div
                        class="col-12 text-center"
                        v-if="item.questionImagePath != null"
                      >
                        <div style="float: right" class="mb-2">
                          <CButton color="info" type="submit">
                            <i class="fa icon-printer"></i> Download Image
                          </CButton>
                        </div>
                        <br />
                        <div style="clear: both"></div>
                        <CRow class="justify-content-center">
                          <CCard
                            style="
                              background: #ffffff;
                              border: #000000;
                              width: 100%;
                            "
                            class="box-shadow"
                            @click="FullImage()"
                          >
                            <div id="printsection">
                              <img
                                style="max-width: 100%; height: 200px"
                                class="image"
                                :src="getPic(item)"
                              />
                            </div>
                          </CCard>
                        </CRow>
                      </div>

                      <span class="columns">
                        <span class="column"></span>
                        <CRow>
                          <div
                            class="col-12 mt-1"
                            v-for="(ans, indexanswer) in item.answer"
                            v-bind:key="indexanswer"
                          >
                            <div class="text-center custom-width-lg">
                              <CRow class="justify-content-center">
                                <CCol sm="12" lg="12" class="mt-4">
                                  <span sm="12" lg="12">
                                    <form>
                                      <label
                                        style="
                                          border: 2px solid #eee;
                                          height: 60px;
                                          width: 100%;
                                          text-align: left;
                                          border-radius: 5px;
                                        "
                                        class="custom-bg-focus"
                                        v-if="ans.Value === 1"
                                      >
                                        <input
                                          type="radio"
                                          name="radio"
                                          v-model="chosen[index]"
                                          :id="ans.Id"
                                          :value="{
                                            id: ans.QuestionId,
                                            name: ans.Answers,
                                            value: ans.Value,
                                          }"
                                          class="radio-custom"
                                        />
                                        <span
                                          class="p-0"
                                          style="
                                            margin-left: 20px;
                                            margin-top: 10px;
                                          "
                                          >A. {{ ans.Answers }}</span
                                        >
                                      </label>

                                      <label
                                        style="
                                          border: 2px solid #eee;
                                          height: 60px;
                                          width: 100%;
                                          text-align: left;
                                          border-radius: 5px;
                                        "
                                        class="custom-bg-focus"
                                        v-if="ans.Value === 2"
                                      >
                                        <input
                                          type="radio"
                                          name="radio"
                                          v-model="chosen[index]"
                                          class="radio-custom"
                                          :id="ans.Id"
                                          :value="{
                                            id: ans.QuestionId,
                                            name: ans.Answers,
                                            value: ans.Value,
                                          }"
                                        />
                                        <span
                                          class="p-0"
                                          style="
                                            margin-left: 20px;
                                            margin-top: 10px;
                                          "
                                          >B. {{ ans.Answers }}</span
                                        >
                                      </label>
                                    </form>
                                  </span>
                                </CCol>

                                <CCol sm="12" lg="12">
                                  <span sm="12" lg="12">
                                    <form>
                                      <label
                                        style="
                                          border: 2px solid #eee;
                                          height: 60px;
                                          width: 100%;
                                          text-align: left;
                                          border-radius: 5px;
                                        "
                                        class="custom-bg-focus"
                                        v-if="ans.Value === 3"
                                      >
                                        <input
                                          type="radio"
                                          name="radio"
                                          v-model="chosen[index]"
                                          class="radio-custom"
                                          :id="ans.Id"
                                          :value="{
                                            id: ans.QuestionId,
                                            name: ans.Answers,
                                            value: ans.Value,
                                          }"
                                        />
                                        <span
                                          class="p-0"
                                          style="
                                            margin-left: 20px;
                                            margin-top: 10px;
                                          "
                                          >C. {{ ans.Answers }}</span
                                        >
                                      </label>

                                      <label
                                        style="
                                          border: 2px solid #eee;
                                          height: 60px;
                                          width: 100%;
                                          text-align: left;
                                          border-radius: 5px;
                                        "
                                        class="custom-bg-focus"
                                        v-if="ans.Value === 4"
                                      >
                                        <input
                                          type="radio"
                                          name="radio"
                                          v-model="chosen[index]"
                                          class="radio-custom"
                                          :id="ans.Id"
                                          :value="{
                                            id: ans.QuestionId,
                                            name: ans.Answers,
                                            value: ans.Value,
                                          }"
                                        />
                                        <span
                                          class="p-0"
                                          style="
                                            margin-left: 20px;
                                            margin-top: 10px;
                                          "
                                          >D. {{ ans.Answers }}</span
                                        >
                                      </label>
                                    </form>
                                  </span>
                                </CCol>
                              </CRow>
                            </div>
                          </div>
                        </CRow>
                      </span>

                      <span v-if="index == Object.keys(AnswerList).length - 1">
                        <CCol sm="12" class="text-left">
                          <!-- <div v-if="Submitted === true && errorcomplete === false">
                            
                            <CButton
                              style="border-radius: 20px"
                              color="primary"
                              class="mt-4 mb-4 bg-custom-primary"
                              disabled
                              size="lg"
                              >Submitted
                            </CButton>
                          </div>
                          <div v-else>
                            <CButton
                              style="border-radius: 20px"
                              color="primary"
                              class="mt-4 mb-4 bg-custom-primary"
                              @click="SubmitAnswer(item.QuestionId)"
                              size="lg"
                              >Confirm
                            </CButton>
                          </div> -->

                          <CButton
      style="border-radius: 20px"
      color="primary"
      class="mt-4 mb-4 bg-custom-primary"
      size="lg"
      @click="submitAnswerAndShowProcessing(item.QuestionId)"
      :disabled="Submitted && !errorcomplete"
    >
      {{ processing ? 'Processing' : errorcomplete ? 'Confirm' : Submitted ? 'Submitted' : 'Confirm' }}
    </CButton>
                        </CCol>
                      </span>
                    </div>
                  </CCard>
                </div>
                <div v-else>
                  no exam generated due to insufficinet question for this
                  subject in this grade.Please select difference option.
                </div>

                <CAlert v-if="errorcomplete === true" color="danger"
                  >ERROR ! Please complete all question</CAlert
                >
                <br /><br />
              </div>
              <!-- <div class="bottom-centers">
                <CButton
                  color="primary"
                  size="lg"
                  @click="SubmitAnswer"
                  class="btn-select-blue"
                  >Next
                </CButton>
              </div> -->
            </div>
          </div>
        </div>
        <CModal class="col-12" :show.sync="ViewImageModal">
          <CRow class="justify-content-center">
            <CCard>
              <img class="imageFull" :src="getPicFull()" />
            </CCard>
          </CRow>
          <template class="modal-footer" hidden="true" #footer>
            <span></span>
          </template>
        </CModal>
      </div>
      <div class="header-top">
        <div class="m-0 custom-header-quiz-title text-left">
          <CButton
          class="d-md-none d-lg-none mt-5 text-white"
          color="info"
          to="ExamBank"
        >
          <img style="max-height: 30px;border-radius:50px" class="mr-2" src="../assets/img/newquiz.jpg" />
          <!-- Now "Start New" is inside a separate <div> and will be on a new line -->
         New Quiz
          </CButton>
        </div>
      </div>
      <div class="header-left">
        <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
      </div>
      <div class="header-right">
        <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
        <br />
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
</template>
  
  <script>
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import _ from "lodash";
import Countdown from "../containers/Countdown.vue";
import Mainlayout from "../containers/TheHeaderExam.vue";

Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import PinchZoom from "vue-pinch-zoom";

Vue.component("pinch-zoom", PinchZoom);
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css",
  ],
};
Vue.use(VueHtmlToPaper, options);
import moment from "moment";

export default {
  name: "Login",
  components: {
    PulseLoader,
    Countdown,
    Mainlayout,
  },
  data() {
    return {
      AnswerList: [],
      qSummary: {},
      SubmittedForm: false,
      Error: false,
      hasScrolledToBottom: false,
      ViewImageModal: false,
      //isDisabled: "",
      //answer: "",
      chosen: [],
      endTime: "",
      Submitted: false,
      errorcomplete: false,
      processing: false,
    };
  },
  async mounted() {
    this.GetQuesDetails();
    this.GetQuizPreview();
  },
  created() {
    // Set the endTime parameter to the current date plus 30 minutes
    const now = moment();
    const endTime = now.add(10, "minutes").format("YYYY-MM-DDTHH:mm:ss");
    this.endTime = endTime;
  },
  methods: {
    GoHomePage() {
      this.$router.push("/ExistingUser");
    },
    //Get details question
    async GetQuesDetails() {
      return this.$API
        .get(this.$GetRandomExam + "?guidId=" + this.$route.query.guidId)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.AnswerList = response.data;
            console.log("AnswerList", this.AnswerList);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    //Get quiz summary
    async GetQuizPreview() {
      this.$API
        .get(this.$GetRandomExam + "?guidId=" + this.$route.query.guidId)
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    //Image
    ViewFullImage(questionFolderName, questionImageName) {
      this.getPicFull(questionFolderName, questionImageName);
      console.log("testing" + questionFolderName + questionImageName);

      this.ViewImageModal = true;

      this.foldername = questionFolderName;
      this.imagename = questionImageName;

      this.getPicFull(this.foldername);
    },
    getPic(AnswerList) {
      return (
        "https://pickiddo.com/Quiz/" +
        AnswerList.questionFolderName +
        "/" +
        AnswerList.questionImageName
      );
    },

    getPicFull() {
      console.log("testing1" + this.foldername + this.imagename);
      return (
        "https://pickiddo.com/Quiz/" + this.foldername + "/" + this.imagename
      );
    },
    submitAnswerAndShowProcessing(questionId) {
    // Set processing to true to show the "Processing" label.
    this.processing = true;

    // Perform the submission logic, e.g., an API request.
    // Once the processing is complete, set processing back to false.
    // You can use a setTimeout or an asynchronous operation to simulate processing.
    setTimeout(() => {
      // Simulate processing completion.
      this.processing = false;

      // Call the actual SubmitAnswer method or perform other actions as needed.
      this.SubmitAnswer(questionId);
    }, 2000); // Simulate 2 seconds of processing, adjust as needed.
  },
    async SubmitAnswer() {
      this.Submitted = true;
      const formData = new FormData();
      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item.value + "console");
        console.log(item.id + "question");

        combinedrates.push({
          ExamQuestionGuid: this.$route.query.guidId,
          ExamStartId: this.$route.query.startId,
          ExamQuestionId: item.id,
          Choice: item.value,
          Answer: item.name,
        });
      }

      let feedData = JSON.stringify(combinedrates);

      if (combinedrates.length < this.AnswerList.length) {
        // this.$dialog
        //         .alert("Please complete all quiz")
        //         .then(function (dialog) {
        //           //console.log("Closed");
        //         });
        this.errorcomplete = true;
      } else {
        formData.append("ansJson", feedData);
        formData.append("startId", this.$route.query.startId);
        console.log("lengt" + combinedrates.length);

        return this.$API
          .post(this.$StudentSubmitAnswerExamAll, formData)
          .then((response) => {
            console.log(response.status);
            console.log(response.data);
            if (response.status == 200) {
              // var startId = response.data;
              // this.GoToRefresh();
              this.GoToPageScore();
              console.log("Ok");
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.data);
            }
          });
      }
    },
    GoToRefresh() {
      window.location.reload();
    },
    GoToPageScore() {
      this.$router.push(
        "/ExamScore?startId=" +
          this.$route.query.startId +
          "&guidId=" +
          this.$route.query.guidId
      );
    },
    async SubmitAnswerWoPopup(questionId) {
      const formData = new FormData();
      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item.value + "console");
        console.log(item.id + "question");

        combinedrates.push({
          QuizTitleId: this.$route.query.quizId,
          StudentId: this.$route.query.studentId,
          QuizStartId: this.$route.query.startId,
          QuizQuestionId: item.id,
          Choice: item.value,
          Answer: item.name,
        });
      }

      let feedData = JSON.stringify(combinedrates);

      formData.append("ansJson", feedData);
      console.log("lengt" + combinedrates.length);

      return this.$API
        .post(this.$StudentSubmitAnswerAll, formData)
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if (response.status == 200 && response.data != null) {
            // var startId = response.data;
            // this.GoToRefresh();
            this.GoToPageScore();
            console.log("Ok");
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.data);
          }
        });
    },
    finish() {
      this.SubmitAnswerWoPopup();
      this.GoToPageScore();
    },
    async SubmitAnswerWoPopup(questionId) {
      const formData = new FormData();
      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item.value + "console");
        console.log(item.id + "question");

        combinedrates.push({
          QuizTitleId: this.$route.query.quizId,
          StudentId: this.$route.query.studentId,
          QuizStartId: this.$route.query.startId,
          QuizQuestionId: item.id,
          Choice: item.value,
          Answer: item.name,
        });
      }

      let feedData = JSON.stringify(combinedrates);

      formData.append("ansJson", feedData);
      console.log("lengt" + combinedrates.length);

      return this.$API
        .post(this.$StudentSubmitAnswerAll, formData)
        .then((response) => {
          console.log(response.status);
          console.log(response.data);
          if (response.status == 200 && response.data != null) {
            // var startId = response.data;
            // this.GoToRefresh();
            this.GoToPageScore();
            console.log("Ok");
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
            console.log(error.response.data);
          }
        });
    },
  },
};
</script>
  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

.imageFull {
  object-fit: fill;
  object-position: center;
  font-family: "object-fit: fill; object-position: center;";
}
/* input[type="radio"] {
    opacity: 0;
  } */
p img {
  width: 100% !important;
}

input[type="radio"] + label {
  color: black;
}

.custom-bg-focus:hover {
  background-color: #007cef;
  color: #fff;
}

.bg-custom-primary {
  background-color: #007cef;
  color: #fff;
}

.custom-bg-focus input:checked + span {
  background-color: #007cef;
  min-height: 60px;
  border-radius: 5px;
  left: -20px;
  top: -10px;
  position: relative;
  width: 100% !important;
  color: #fff;
}

.custom-bg-focus input {
  position: absolute;
  left: -9999px;
}
.custom-bg-focus span {
  display: flex;
  align-items: center;
  transition: 0.25s ease;
}
.custom-bg-focus span:after {
  display: flex;
  flex-shrink: 0;
  background-color: #007cef;
}

.custom-bg-focus span {
  display: flex;
  align-items: center;
  transition: 0.25s ease;
}

label span:hover {
  background-color: #007cef;
  color: #fff;
}

label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  /* background-color: #fff; */
  margin-left: 20px;
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.bottom-center {
  vertical-align: bottom;
  position: fixed;
  bottom: 20px;
  text-align: center;
  float: none;
  left: 0;
  right: 0;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
}
</style>